'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('friartux/events/create'));
    processInclude(require('friartux/components/inputDate'));
});
